export default "__VITE_ASSET__DPSTHl1n__"